export const ASSIGN_POLYNOMIAL_GROUP_GET_GROUP_LIST_INIT = 'ASSIGN_POLYNOMIAL_GROUP_GET_GROUP_LIST_INIT';
export const ASSIGN_POLYNOMIAL_GROUP_GET_GROUP_LIST_SUCCESS = 'ASSIGN_POLYNOMIAL_GROUP_GET_GROUP_LIST_SUCCESS';
export const ASSIGN_POLYNOMIAL_GROUP_GET_GROUP_LIST_FAILURE = 'ASSIGN_POLYNOMIAL_GROUP_GET_GROUP_LIST_FAILURE';

export const ASSIGN_POLYNOMIAL_GROUP_GET_GROUP_POLYNOMIALS_LIST_INIT = 'ASSIGN_POLYNOMIAL_GROUP_GET_GROUP_POLYNOMIALS_LIST_INIT';
export const ASSIGN_POLYNOMIAL_GROUP_GET_GROUP_POLYNOMIALS_LIST_SUCCESS = 'ASSIGN_POLYNOMIAL_GROUP_GET_GROUP_POLYNOMIALS_LIST_SUCCESS';
export const ASSIGN_POLYNOMIAL_GROUP_GET_GROUP_POLYNOMIALS_LIST_FAILURE = 'ASSIGN_POLYNOMIAL_GROUP_GET_GROUP_POLYNOMIALS_LIST_FAILURE';

export const ASSIGN_POLYNOMIAL_GROUP_GET_POLYNOMIAL_LIST_INIT = 'ASSIGN_POLYNOMIAL_GROUP_GET_POLYNOMIAL_LIST_INIT';
export const ASSIGN_POLYNOMIAL_GROUP_GET_POLYNOMIAL_LIST_SUCCESS = 'ASSIGN_POLYNOMIAL_GROUP_GET_POLYNOMIAL_LIST_SUCCESS';
export const ASSIGN_POLYNOMIAL_GROUP_GET_POLYNOMIAL_LIST_FAILURE = 'ASSIGN_POLYNOMIAL_GROUP_GET_POLYNOMIAL_LIST_FAILURE';

export const ASSIGN_POLYNOMIAL_GROUP_GET_POLYNOMIAL_GROUPS_LIST_INIT = 'ASSIGN_POLYNOMIAL_GROUP_GET_POLYNOMIAL_GROUPS_LIST_INIT';
export const ASSIGN_POLYNOMIAL_GROUP_GET_POLYNOMIAL_GROUPS_LIST_SUCCESS = 'ASSIGN_POLYNOMIAL_GROUP_GET_POLYNOMIAL_GROUPS_LIST_SUCCESS';
export const ASSIGN_POLYNOMIAL_GROUP_GET_POLYNOMIAL_GROUPS_LIST_FAILURE = 'ASSIGN_POLYNOMIAL_GROUP_GET_POLYNOMIAL_GROUPS_LIST_FAILURE';

export const ASSIGN_POLYNOMIAL_GROUP_SAVE_GROUP_POLYNOMIAL_INIT = 'ASSIGN_POLYNOMIAL_GROUP_SAVE_GROUP_POLYNOMIAL_INIT';
export const ASSIGN_POLYNOMIAL_GROUP_SAVE_GROUP_POLYNOMIAL_SUCCESS = 'ASSIGN_POLYNOMIAL_GROUP_SAVE_GROUP_POLYNOMIAL_SUCCESS';
export const ASSIGN_POLYNOMIAL_GROUP_SAVE_GROUP_POLYNOMIAL_FAILURE = 'ASSIGN_POLYNOMIAL_GROUP_SAVE_GROUP_POLYNOMIAL_FAILURE';

export const ASSIGN_POLYNOMIAL_GROUP_SAVE_POLYNOMIAL_GROUP_INIT = 'ASSIGN_POLYNOMIAL_GROUP_SAVE_POLYNOMIAL_GROUP_INIT';
export const ASSIGN_POLYNOMIAL_GROUP_SAVE_POLYNOMIAL_GROUP_SUCCESS = 'ASSIGN_POLYNOMIAL_GROUP_SAVE_POLYNOMIAL_GROUP_SUCCESS';
export const ASSIGN_POLYNOMIAL_GROUP_SAVE_POLYNOMIAL_GROUP_FAILURE = 'ASSIGN_POLYNOMIAL_GROUP_SAVE_POLYNOMIAL_GROUP_FAILURE';

export const ASSIGN_POLYNOMIAL_GROUP_DOWNLOAD_IMPORT_FILE_INIT = 'ASSIGN_POLYNOMIAL_GROUP_DOWNLOAD_IMPORT_FILE_INIT';
export const ASSIGN_POLYNOMIAL_GROUP_DOWNLOAD_IMPORT_FILE_SUCCESS = 'ASSIGN_POLYNOMIAL_GROUP_DOWNLOAD_IMPORT_FILE_SUCCESS';
export const ASSIGN_POLYNOMIAL_GROUP_DOWNLOAD_IMPORT_FILE_FAILURE = 'ASSIGN_POLYNOMIAL_GROUP_DOWNLOAD_IMPORT_FILE_FAILURE';

export const ASSIGN_POLYNOMIAL_GROUP_IMPORT_INIT = 'ASSIGN_POLYNOMIAL_GROUP_IMPORT_INIT';
export const ASSIGN_POLYNOMIAL_GROUP_IMPORT_SUCCESS = 'ASSIGN_POLYNOMIAL_GROUP_IMPORT_SUCCESS';
export const ASSIGN_POLYNOMIAL_GROUP_IMPORT_FAILURE = 'ASSIGN_POLYNOMIAL_GROUP_IMPORT_FAILURE';
export const ASSIGN_POLYNOMIAL_GROUP_IMPORT_RESET = 'ASSIGN_POLYNOMIAL_GROUP_IMPORT_RESET';

export const ASSIGN_POLYNOMIAL_GROUP_GET_PERIODS_LIST_INIT = 'ASSIGN_POLYNOMIAL_GROUP_GET_PERIODS_LIST_INIT';
export const ASSIGN_POLYNOMIAL_GROUP_GET_PERIODS_LIST_SUCCESS = 'ASSIGN_POLYNOMIAL_GROUP_GET_PERIODS_LIST_SUCCESS';
export const ASSIGN_POLYNOMIAL_GROUP_GET_PERIODS_LIST_FAILURE = 'ASSIGN_POLYNOMIAL_GROUP_GET_PERIODS_LIST_FAILURE';

export const ASSIGN_POLYNOMIAL_GROUP_SET_PERIOD_ID = 'ASSIGN_POLYNOMIAL_GROUP_SET_PERIOD_ID';

export const ASSIGN_POLYNOMIAL_GROUP_RESET = 'ASSIGN_POLYNOMIAL_GROUP_RESET';
export const ASSIGN_POLYNOMIAL_GROUP_SOFT_RESET = 'ASSIGN_POLYNOMIAL_GROUP_SOFT_RESET';


// WEBPACK FOOTER //
// ./source/client/actions/assignPolynomialGroupAdmin/types.js